/**
 * API endpoint path segments (appended to API_BASE_URL).
 * Centralizes all backend route paths used in apiService.ts,
 * rcaApiService.ts, smartColumnApiService.ts, and pivotTableApiService.ts.
 */

export const API_PATHS = {
  // Data endpoints
  SALES_DATA: "/sales-data",
  INVENTORY: "/inventory",
  PRODUCTS: "/products",
  AMAZON_ADS_DATA: "/amazon-ads-data",

  // Market Watch
  MARKET_WATCH_FILTERS: "/market-watch/filters",
  MARKET_WATCH_FILTER_OPTIONS: "/market-watch/filters/options",
  MARKET_WATCH_DATA: "/market-watch/data",
  MARKET_WATCH_ANALYZE: "/market-watch/analyze",
  MARKET_WATCH_ANALYZE_PROGRESS: "/market-watch/analyze/progress",
  MARKET_WATCH_CONFIG_SETTINGS: "/market-watch/config/settings",

  // RCA
  RCA_PLAN: "/rca/plan",
  RCA_ANALYZE: "/rca/analyze",
  RCA_PROGRESS: "/rca/progress",
  RCA_COLUMN_DESCRIPTIONS: "/rca/column-descriptions",

  // Templates
  TEMPLATES_CALCULATED_COLUMNS: "/templates/calculated_columns",
  TEMPLATES_USER_TEMPLATE: "/templates/user_template",

  // Users
  USERS: "/users",

  // Fuzzy Search
  FUZZY_SEARCH: "/fuzzy_search",
  FUZZY_SEARCH_GROUNDING_TABLE: "/fuzzy_search/generate_grounding_table",
  FUZZY_SEARCH_AUTO_SETUP: "/fuzzy_search/generate_auto_setup",

  // Prompts & Insights
  PROMPT_HISTORY: "/prompt_history",
  INSIGHTS_HISTORY: "/insights_history",
} as const;
